"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = require("react");
var _useProduct = require("@deosite/api/hooks/REST/useProduct");
var _usePriceWithCurrency = _interopRequireDefault(require("@deosite/api/hooks/common/usePriceWithCurrency"));
var _LanguageProvider = require("@deosite/api/hooks/common/LanguageProvider");
var _percentDecrease = _interopRequireDefault(require("@deosite/helpers/percentDecrease"));
var _HitProvider = require("../provider/HitProvider");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useProductHit = function useProductHit() {
  var _useHit = (0, _HitProvider.useHit)(),
    hitProduct = _useHit.hitProduct,
    setHitProduct = _useHit.setHitProduct,
    sale = _useHit.sale;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var priceWithCurrency = (0, _usePriceWithCurrency["default"])();
  (0, _react.useEffect)(function () {
    var getProduct = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(sale) {
        var productResult, product, lowestPrice;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _useProduct.fetcher)(sale.sku, null, language);
              case 2:
                productResult = _context.sent;
                product = productResult.product;
                if (product) {
                  _context.next = 6;
                  break;
                }
                throw "No product in hit, sku: ".concat(sale.sku);
              case 6:
                lowestPrice = product.price.lowestPrice || product.price.special || product.price.regular;
                setHitProduct({
                  name: product.name,
                  priceHit: priceWithCurrency(sale.price),
                  image: product.image,
                  lowestPrice: priceWithCurrency(lowestPrice),
                  percentDecrease: (0, _percentDecrease["default"])(lowestPrice, sale.price),
                  url: product.url,
                  sku: product.sku
                });
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function getProduct(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    if (sale !== null && sale !== void 0 && sale.sku && (sale === null || sale === void 0 ? void 0 : sale.sku) !== (hitProduct === null || hitProduct === void 0 ? void 0 : hitProduct.sku)) {
      getProduct(sale)["catch"](console.error);
    }
  }, [sale === null || sale === void 0 ? void 0 : sale.sku]);
  return _objectSpread({}, hitProduct);
};
var _default = useProductHit;
exports["default"] = _default;